import {
    Address,
    AddressState,
    BasisActions,
    BasisState,
    BasisType,
    CustomerEmail,
    GeneralActions,
    NotAvailableState,
    NotAvailableStateActions,
} from '@raskrask-dk/bookingflow-state-machine'
import { Validators } from '@raskrask-dk/raskrask-utils'
import { ReactElement, useEffect, useState } from 'react'
import { useBFSM } from '../../../contexts/bfsmContext'
import { useServiceCombinations } from '../../../contexts/serviceCombinationsContext'
import { BasisTypeBF } from '../../../models'
import { useAppDispatch } from '../../../redux/hooks'
import { setErrorcase } from '../../../redux/reducers/appSettings'
// import BasisTypeBF from '../../../models/BasisTypeBF'
import { useBFSMValue } from '../../../services/hooks/useBFSMValues'
import NoPartnerAvailableTemplate from './template'

const NoPartnerAvailablePage = (): ReactElement => {
    const [BFSM] = useBFSM()
    const dispatch = useAppDispatch()

    const [basisType] = useBFSMValue<
        BasisState,
        BasisActions.SetBasisType,
        'basisType'
    >('basisType', BasisActions.SetBasisType)
    const [email, setEmail] = useBFSMValue<
        NotAvailableState,
        NotAvailableStateActions.SetSignUpEmail,
        'email'
    >('email', NotAvailableStateActions.SetSignUpEmail)
    const [selectedBasisTypes, setSelectedBasisTypes] = useBFSMValue<
        NotAvailableState,
        NotAvailableStateActions.SetBasisTypes,
        'basisTypes'
    >('basisTypes', NotAvailableStateActions.SetBasisTypes)
    const [antiSpam, setAntiSpam] = useState(false)
    const basisTypes = Object.values(useServiceCombinations().basisTypes)
        .map((bt) => {
            const { basisTypeId, basisTypeName } = bt
            return BasisTypeBF.fromDTO({
                id: basisTypeId,
                name: basisTypeName,
                available: true,
                customerTypes: [],
            })
        })
        .filter(
            (bt, i, bts) => bts.findIndex((lbts) => lbts.id === bt.id) === i
        )

    const isValidEmail = Validators.emailValidator(email ?? '')

    const onSignUpSubmit = (): void => {
        if (antiSpam) return
        if (!antiSpam) setAntiSpam(true)
        if (isValidEmail) {
            const { address } = BFSM.getData<AddressState>()
            const { basisTypes, email } = BFSM.getData<NotAvailableState>()
            const sendData = async () => {
                const result = await BFSM.repo.createGeneralLead({
                    address: address as Address,
                    basisTypeIds: (basisTypes as BasisType[]).map(
                        (bt) => bt.id
                    ),
                    email: email as CustomerEmail,
                })
                if (result.status === 200) {
                    window.location.href =
                        'https://www.raskrask.dk/bekraeftelse-23-general-lead/'
                } else {
                    dispatch(setErrorcase('Default'))
                    BFSM.doAction(GeneralActions.GoToErrorState, undefined)
                }
            }
            sendData()
        }
    }

    const onChangeSignUp = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
    }

    const onClickBasisType = (basisTypeId: number) => {
        // Find the BasisTypeBF object corresponding to the basisTypeID clicked on
        const basisTypeBF = basisTypes.find((bt) => bt.id === basisTypeId)
        if (basisTypeBF) {
            // If the item clicked on has already been picked, unselect it.
            if (
                selectedBasisTypes &&
                selectedBasisTypes.find((sbt) => sbt.id === basisTypeId)
            )
                setSelectedBasisTypes([
                    ...selectedBasisTypes.filter(
                        (sbt) => sbt.id !== basisTypeBF.id
                    ),
                ])
            // If there has already been selected another BasisType, add clicked Basistype to array.
            else if (selectedBasisTypes)
                setSelectedBasisTypes([...selectedBasisTypes, basisTypeBF])
            // If no Basistypes has been selected at this point. Pick the selected one.
            else setSelectedBasisTypes([basisTypeBF])
        }
    }
    useEffect(() => {
        if (basisType && !selectedBasisTypes) {
            setSelectedBasisTypes([basisType])
        }
    }, [basisType])

    return (
        <NoPartnerAvailableTemplate
            basisType={basisType}
            isValidEmail={isValidEmail}
            onClickSubmit={onSignUpSubmit}
            onChangeSignUp={onChangeSignUp}
            basisTypes={basisTypes}
            selectedBasisTypes={selectedBasisTypes}
            onClickBasisType={onClickBasisType}
        />
    )
}

export default NoPartnerAvailablePage
